const DEFAULT_TIMEOUT_MS = 8000;

const fetchUtil = async (
  url: string,
  method: string,
  body: object,
  ctype: string,
  useToken: boolean,
  useHeaders?: boolean,
  token?: string,
  timeoutMs: number = DEFAULT_TIMEOUT_MS
) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  let options: any = {};
  if (method === 'GET') {
    options = useHeaders
      ? { method, signal: controller.signal }
      : {
        method,
        headers: requestHeaders(ctype, useToken, token),
        signal: controller.signal,
      };
  } else {
    options = {
      method,
      headers: requestHeaders(ctype, useToken, token),
      body: JSON.stringify(body),
      signal: controller.signal,
    };
  }
  try {
    const res = await fetch(url, options);
    return await parseStatus(res.status, res);
  } finally {
    clearTimeout(timer);
  }
};
const parseStatus = (status: any, res: any) => {
  return new Promise((resolve, reject) => {
    if (status >= 200 && status < 300) {
      if (res.url.indexOf('.html') > -1) {
        return resolve(res);
      }
      res.json().then((response: any) => resolve(response));
    } else {
      res.json().then((response: any) => reject(response));
    }
  });
};
const requestHeaders = (ctype: string, useToken: boolean, token?: string) => {
  return useToken
    ? {
      'Content-Type': ctype || 'application/json',
      Authorization: token,
    }
    : {
      'Content-Type': ctype || 'application/json',
    };
};
export default fetchUtil;